import {
PARK_ADMIN_BULK_UPLOAD_REQUEST,
PARK_ADMIN_BULK_UPLOAD_SUCCESS,
PARK_ADMIN_BULK_UPLOAD_FAILURE,
} from "../actions/ParkAdminBulkUploadActions";

const initialState = {
loading: false,
success: false,
error: null,
data: null,
};

const parkAdminBulkUploadReducer = (state = initialState, action) => {
switch (action.type) {
case PARK_ADMIN_BULK_UPLOAD_REQUEST:
return {
...state,
loading: true,
success: false,
error: null,
};

case PARK_ADMIN_BULK_UPLOAD_SUCCESS:
  return {
    ...state,
    loading: false,
    success: true,
    data: action.payload,
    error: null,
  };

case PARK_ADMIN_BULK_UPLOAD_FAILURE:
  return {
    ...state,
    loading: false,
    success: false,
    error: action.payload,
  };

default:
  return state;


}
};

export default parkAdminBulkUploadReducer;
